import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from './Sidebar';
import Header from './Header';

function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Load retro font
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Share+Tech+Mono:wght@400&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    
    return () => {
      if (document.head.contains(link)) {
        document.head.removeChild(link);
      }
    };
  }, []);

  const retroStyle = {
    fontFamily: '"Share Tech Mono", monospace',
  };

  return (
    <>
      <style jsx>{`
        .retro-gradient {
          background: linear-gradient(to bottom, #2C3E50, #1A2530);
        }
        .studio-card {
          backdrop-filter: blur(10px);
          border: 1px solid rgba(241, 196, 15, 0.2);
          background: rgba(52, 73, 94, 0.3);
        }
        .hero-title {
          text-shadow: 2px 2px 0px #E67E22, 4px 4px 0px #D35400, 2px 2px 10px rgba(241, 196, 15, 0.5);
          -webkit-text-stroke: 1px #E67E22;
        }
        .retro-button {
          box-shadow: 0 6px 0 #C0392B, 0 8px 15px rgba(231, 76, 60, 0.3);
          transform: translateY(0);
          transition: all 0.1s ease;
        }
        .retro-button:hover {
          transform: translateY(2px);
          box-shadow: 0 4px 0 #C0392B, 0 6px 12px rgba(231, 76, 60, 0.3);
        }
        .retro-button:active {
          transform: translateY(6px);
          box-shadow: 0 0px 0 #C0392B, 0 2px 8px rgba(231, 76, 60, 0.3);
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }
        .floating-icon {
          animation: float 6s ease-in-out infinite;
        }
        .game-element {
          animation: pulse 2s ease-in-out infinite alternate;
        }
        @keyframes pulse {
          0% { opacity: 0.6; }
          100% { opacity: 1; }
        }
        .studio-scrollbar {
          scrollbar-width: thin;
          scrollbar-color: rgba(241, 196, 15, 0.3) transparent;
        }
        .studio-scrollbar::-webkit-scrollbar {
          width: 12px;
        }
        .studio-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .studio-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(241, 196, 15, 0.3);
          border-radius: 6px;
          border: 2px solid transparent;
          background-clip: padding-box;
        }
        .studio-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(241, 196, 15, 0.5);
          background-clip: padding-box;
        }
        /* Ensure no white background during route transitions */
        body {
          background: #2C3E50;
          overflow-x: hidden;
        }
        #root {
          background: transparent;
          min-height: 100vh;
        }
        
        /* Prevent white space on mobile browsers */
        html {
          background: #2C3E50;
          overflow-x: hidden;
        }
        
        /* Mobile-specific content area adjustments */
        @media (max-width: 1024px) {
          .flex-1.overflow-y-auto {
            min-height: 0;
            flex: 1;
          }
        }
      `}</style>

      <div className="flex h-screen overflow-hidden retro-gradient bg-slate-800" style={retroStyle}>
        {/* Retro background effects */}
        <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        </div>

        {/* Sidebar */}
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-hidden z-10">
          {/* Site header */}
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

          {/* Main content wrapper */}
          <div className="flex-1 overflow-y-auto studio-scrollbar bg-transparent">
            <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(Layout);